export default __webpack_public_path__ + "static/media/report-bug-button.c780491a.svg";